import { Component } from '@angular/core';
import { NavController,AlertController,App} from 'ionic-angular';
import { AppState } from '../../../app/app.global';
import { VersionUpdatePage } from "../version/updateversion";
import { WebService } from '../../../providers/service/webservice';
import { LoginPage } from '../../login/login/login';
import { TabsPage } from '../../tabs/tabs/tabs';
import { StorageService } from '../../../providers/service/storageservice';
import { InAppBrowser  } from '@ionic-native/in-app-browser';
import { LOGOUT_CAS,LOGOUTWX,SYSTEM_URL } from '../../../providers/config/serviceurl';
import { HttpService } from '../../../providers/service/httpservice';
import { Http, Headers, RequestOptions } from '@angular/http';
/**
 * Generated class for the SettingPage page.
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting',
  templateUrl: 'setting.html',
})
export class SettingPage {
	
	user:any =null;
	opid:any = null;
	constructor(public navCtrl: NavController,public appCtrl: App,private alertCtrl: AlertController
		,public global: AppState,private webService:WebService,public inAppBrowser: InAppBrowser,
		public http: Http,private httpService:HttpService) {
		this.user = StorageService.getObj('currentUser');
		this.opid =  StorageService.getObj('opid')
  }
//版本更新
  versiUpdate(){
		// this.navCtrl.push(VersionUpdatePage,{});
		this.appCtrl.getRootNav().push(VersionUpdatePage,{});
  }
  //清除缓存
	cleanCache() {
	  let alert = this.alertCtrl.create({
	    message: '是否清理缓存?',
	    buttons: [
	      {
	        text: '取消',
	        role: 'cancel',
	      },
	      {
	        text: '确认',
	        handler: () => {
						localStorage.setItem('msgdelteItem',"");//清除消息删除缓存
						localStorage.setItem('msgsignUnRead',"");//清除消息标记未读缓存
						localStorage.setItem('msgSettingListCache',"");//清除消息设置是否显示缓存
						localStorage.setItem('colorTheme',"");//清除设置颜色缓存
						localStorage.setItem('homeSet',"");//清除首页排序缓存
						
/*	          $ionicHistory.clearCache();
	          $ionicHistory.clearHistory();*/
	        }
	      }
	    ]
	  });
	  alert.present();
	}


	loginOut2(){
		let alert = this.alertCtrl.create({
			message: '是否退出',
			buttons: ['取消',
		   	{ text:'确定',
					handler:()=>{
						let params = {'opid':this.opid};
						this.httpService.post2(LOGOUTWX,params).then(anyObj =>this.handleThings(anyObj)); 
					}
		    }]
			});
			alert.present();
	}
	handleThings(obj :any){
  	if(obj && obj.code === 200){
			StorageService.setObj("oldUserId", "");
			StorageService.setObj("currentUser", "");
			StorageService.setObj("resourceUrl", "");
			// StorageService.remove('currentUser');
			const link = this.urlencode(SYSTEM_URL);
			const browser = this.inAppBrowser.create(LOGOUT_CAS + "?service="+link,'_self','location=yes');
  	}
	}


  loginOut(){
		let params = {'opid':this.opid};		
		console.info("params:"+ params);
		let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
		
    this.http.post(LOGOUTWX,this.httpService.toBodyString(params), new RequestOptions({ headers: headers })).toPromise();      
		const link = this.urlencode(SYSTEM_URL + "?opid=" + this.opid);
		console.info("url::::" + LOGOUT_CAS + "?service="+link)
		this.http.get(LOGOUT_CAS + "?service="+link,null).toPromise();
	
		StorageService.remove('currentUser');		
		this.navCtrl.setRoot(LoginPage);
	}

	
	urlencode (str) {  
    str = (str + '').toString();   
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
    replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');  
	} 


}



// WEBPACK FOOTER //
// ./src/pages/about/setting/setting.ts